
import { useState, useRef, useEffect, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { RadioButton } from 'primereact/radiobutton';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { TreeSelect } from 'primereact/treeselect';

import Menubar1 from '../Components/Menubar1';

import { SORT_OPTIONS, DEBUG, API_BASE_URL_UAT, API_BASE_URL, BOOK_LIST } from '../Utilities/constant';

import { useShared } from '../Utilities/allContext1';
import reducer from '../Imports/reducerImports';

export default function MemberList(){

    const { setMemberList } = reducer;
    const { putMemberListItem, getDistrictList, getSupervisorList, getManagerList, getAssignList, updateAssignList, getServiceList, getMemberList } = useShared();

    const dispatch = useDispatch(); // dispatch(
    const memberList = useSelector((state) => state.all.memberList);
    const districtList = useSelector((state) => state.all.districtList);

    const [selectedMemberList, setSelectedMemberList] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [first, setFirst] = useState(0);
    //const [globalFilter, setGlobalFilter] = useState('');
    const [districtOptionList, setDistrictOptionList] = useState([]);

    const [filters, setFilters] = useState({
        chineseName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        districtId: { value: null, matchMode: FilterMatchMode.EQUALS },
    });

    const [nodes, setNodes] = useState(null);
    const [selected4DistrictFilter, setSelected4DistrictFilter] = useState(null);    
    const [selected4DistrictEditor, setSelected4DistrictEditor] = useState(null);    

    const generateNodes = (list) => {
        const grouped = list.reduce((acc, item) => {
            // Group by area
            if (!acc[item.area]) {
                acc[item.area] = [];
            }
            acc[item.area].push({
                key: item.value.toString(),
                label: item.label
            });
            return acc;
        }, {});

        // Convert grouped data into nodes structure
        const nodes = Object.entries(grouped).map(([area, children]) => ({
            key: area,
            label: area,
            children
        }));

        return nodes;
    };

    const onRowEditComplete = (e) => {
        const updatedMemberList = [...memberList]; // Create a copy of the current member list
        const { newData } = e; // Get the new data of the edited row
        const originalIndex = memberList.findIndex(member => member.id === newData.id); // Find the original index using a unique identifier from newData
        if (originalIndex !== -1) {
            updatedMemberList[originalIndex] = { ...updatedMemberList[originalIndex], ...newData }; // Update the specific row in the original member list
            dispatch(setMemberList(updatedMemberList)); // Dispatch to update Redux store
        }

        const item = {
            //Credential: credential,
            ID: newData.id,
            Sort: newData.sort,
            ChineseName: newData.chineseName,
            Gender: newData.gender,
            DistrictID: newData.districtId,
            FullAddress: newData.fullAddress,
            Updated: { 
                Sort: true,
                ChineseName: true,
                Gender: true,
                DistrictID: true,
                FullAddress: true,
            }
        }
        putMemberListItem(item);
    };

    const onChangeChineseName4Filter = (currentRow, e) => {

        const value = e.target.value; // Get the selected value from the dropdown

        setFilters((prevFilters) => ({
            ...prevFilters,
            chineseName: { value, matchMode: FilterMatchMode.CONTAINS }, // Update the districtId filter
        }));

        currentRow.filterCallback(value); // Trigger the DataTable's internal filtering    

    }

    const chineseNameFilterTemplate = (currentRow) => {
        return (
            <InputText 
                style={{ minWidth: '10rem' }}
                type="text" 
                placeholder="搜尋" 
                value={currentRow.value || ''} 
                onChange={(e) => onChangeChineseName4Filter(currentRow, e)}
                showClear={true}
            />
        );
    };    

    const onChangeDistrictFilter = (currentRow, e) => {

        const value = e.value; // Get the selected value from the dropdown

        setSelected4DistrictFilter(value);
        setFilters((prevFilters) => ({
            ...prevFilters,
            districtId: { value, matchMode: FilterMatchMode.EQUALS }, // Update the districtId filter
        }));

        //currentRow.filterCallback(value); // Trigger the DataTable's internal filtering   
        currentRow.filterApplyCallback(value);

    }

    // const districtFilter = (currentRow) => {
    //     return (
    //         <TreeSelect 
    //             value={currentRow.value} 
    //             options={nodes} 
    //             onChange={(e) => onChangeDistrictFilter(currentRow, e)}
    //             placeholder="選擇地區"
    //             className="p-column-filter" 
    //         />
    //     );
    // };    

    const handleNodeSelect = (currentRow, e) => {      
        let value;          
        if (e.node.children) { // Check if the selected node has children (i.e., it's a group)
            value = null;
        } else {            
            value = e.node.key; // If it's a node, update the filter value
        }
        setFilters((prevFilters) => ({
            ...prevFilters,
            districtId: { value: value, matchMode: FilterMatchMode.EQUALS },
        }));
        currentRow.filterApplyCallback(value); // Apply the filter value
        setSelected4DistrictFilter(value); // Set the selected value
    };

    const districtFilter = (currentRow) => {

        return (
            <TreeSelect
                value={currentRow.value}
                options={nodes}
                onNodeSelect={(e) => handleNodeSelect(currentRow, e)} // Handle node selection
                placeholder="選擇地區"
                className="p-column-filter"
            />
        );
};

    const onChangeDistrictEditor = (currentRow, e) => {
        const value = Number(e.value); // Get the selected value from the dropdown
        // setSelected4DistrictEditor(value);
        // setFilters((prevFilters) => ({
        //     ...prevFilters,
        //     districtId: { value, matchMode: FilterMatchMode.EQUALS }, // Update the districtId filter
        // }));
        currentRow.editorCallback(value); // Trigger the DataTable's internal filtering            
    }

    const districtEditor = (currentRow) => {
        // setSelected4DistrictEditor(currentRow.value);
        return (
            // <Dropdown
            //     value={currentRow.value}
            //     options={districtOptionList}
            //     //placeholder="選擇地區"
            //     onChange={(e) => currentRow.editorCallback(e.value)}
            //     itemTemplate={(option) => {
            //         return <div>{option.label}</div>; // Return a React element
            //     }}
            // />
            <TreeSelect 
                value={currentRow.value || ''} 
                options={nodes} 
                //onChange={(e) => setSelectedNodeKey(e.value)}
                onChange={(e) => onChangeDistrictEditor(currentRow, e)}
                placeholder="選擇地區"
                className="p-column-filter" 
                //showClear={true}
            />            
        );
    };

    const genderEditor = (currentRow) => {
        return (
            // <div className="flex flex-wrap gap-3">
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ marginRight: '10px' }}>
                    <RadioButton value="M" onChange={(e) => currentRow.editorCallback(e.value)}  checked={currentRow.rowData.gender === 'M'} />
                    <label className="ml-2">M</label>
                </div>
                <div>
                    <RadioButton value="F" onChange={(e) => currentRow.editorCallback(e.value)}  checked={currentRow.rowData.gender === 'F'} />
                    <label className="ml-2">F</label>
                </div>
            </div>            
        );
    }

    const sortEditor = (currentRow) => {
        return (
            <Dropdown
                value={currentRow.value}
                options={SORT_OPTIONS}
                onChange={(e) => currentRow.editorCallback(e.value)}
                itemTemplate={(option) => {
                    return <div>{option.label}</div>; // Return a React element
                }}
            />
        );
    };

    const chineseNameEditor = (currentRow) => {
        return <InputText style={{ width: '100px' }} type="text" value={currentRow.value} onChange={(e) => currentRow.editorCallback(e.target.value)} showClear/>;
    };

    const districtIdTemplate = (rowData) => {
        const item = districtList.find(district => district.id === rowData.districtId);
        if (!item) {
            return 'Unknown'; // Fallback value if no match is found
        }        
        return `${item.sort}:${item.district}`; // Truncate to first 10 characters
    };

    const fullAddressTemplate = (rowData) => {
        return rowData.fullAddress !== null ? rowData.fullAddress.substring(0, 10) + ' ......' : null; // Truncate to first 10 characters
    };

    useEffect(() => {
        const districtOptionList = districtList.map(item => ({
            value: item.id,       // Map 'id' to 'value'
            label: `${item.sort}:${item.district}`,  // Map 'district' to 'label'
            area: item.area,
        }));
        setDistrictOptionList(districtOptionList);

        const nodes = generateNodes(districtOptionList);
        setNodes(nodes);
    }, []);

    return (

        <div>

            <Menubar1 />

            {/* <span>
                <InputText 
                    type="search" 
                    onInput={(e) => setGlobalFilter(e.target.value)} 
                    placeholder="搜尋姓名" 
                    style={{ margin: '5px', padding: '5px' }}
                />
            </span> */}

            {/* <div className="card flex justify-content-center">
                <TreeSelect value={selectedNodeKey} onChange={(e) => setSelectedNodeKey(e.value)} options={nodes} 
                    className="md:w-20rem w-full" placeholder="Select Item"></TreeSelect>
            </div>             */}

            <DataTable 
                scrollable 
                editMode="row"
                style={{ margin: '10px', padding: '5px' }}
                size={'normal'}
                value={memberList} 
                paginator rows={rowsPerPage} rowsPerPageOptions={[10, 25, 50, 100, 500]} 
                first={first}
                paginatorTemplate="RowsPerPageDropdown PrevPageLink CurrentPageReport NextPageLink"
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                selection={selectedMemberList} 
                // onSelectionChange={(e) => updateSelectedMemberList3(e.value)} 
                dataKey="id" 
                // onPage={updateRowsPerPage3} // Update rows per page state
                //globalFilter={globalFilter}
                onRowEditComplete={onRowEditComplete}
                emptyMessage="沒有相關資料"

                filterDisplay="row"
                //globalFilterFields={['chineseName']}
                filters={filters}
                onFilter={(e) => setFilters(e.filters)}                
            >
                <Column 
                    rowEditor 
                    headerStyle={{ minWidth: '8rem' }} 
                    bodyStyle={{ textAlign: 'center' }}
                />
                <Column 
                    field="sort" 
                    headerStyle={{ whiteSpace: 'nowrap' }} 
                    header="排序" 
                    bodyStyle={{ whiteSpace: 'nowrap' }} 
                    editor={(currentRow) => sortEditor(currentRow)}
                />
                <Column 
                    field="chineseName" 
                    headerStyle={{ whiteSpace: 'nowrap' }} 
                    header="姓名" 
                    bodyStyle={{ whiteSpace: 'nowrap' }} 
                    editor={(currentRow) => chineseNameEditor(currentRow)}
                    filter 
                    //filterPlaceholder="搜尋" 
                    //style={{ minWidth: '10rem' }} 
                    filterElement={chineseNameFilterTemplate}
                    showFilterMenu={false}
                />
                <Column 
                    field="gender" 
                    headerStyle={{ whiteSpace: 'nowrap' }} 
                    header="性別" 
                    bodyStyle={{ whiteSpace: 'nowrap' }} 
                    editor={(currentRow) => genderEditor(currentRow)}
                />
                <Column 
                    field="districtId" 
                    headerStyle={{ whiteSpace: 'nowrap' }} 
                    header="地區" 
                    bodyStyle={{ whiteSpace: 'nowrap' }} 
                    body={districtIdTemplate}
                    editor={(currentRow) => districtEditor(currentRow)} 
                    filter 
                    filterElement={districtFilter}
                    showFilterMenu={false}
                />
                {/* <Column 
                    field="fullAddress" 
                    headerStyle={{ whiteSpace: 'nowrap' }} 
                    header="地址" 
                    bodyStyle={{ whiteSpace: 'nowrap' }} 
                    body={fullAddressTemplate}
                /> */}
            </DataTable>
        </div>

    )

}